module.exports = __webpack_public_path__ + "img/img25.8eed202b.jpg";